import { type FC } from 'react'

export const ChartsSkeletonPage: FC = () => null
